import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';

export const VideoOffIcon = styled(Icon)`
    --icon-color: ${(props) => props.theme.root.colors.basicColors.black['95%']};
`;
